export const ITEM_TRANSITION_TIMING = 300
export const ITEM_SCROLL_TIME = 2000
export const LOOP_SLIDERS = 4
